import { Drawer } from 'antd';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import FunnelIcon from 'assets/Icons/FunnelIcon';
import React, { useEffect, useState } from 'react';

import ButtonDefault, {
  ButtonVariants,
} from '@/components/shared/basic/button';
import CategoriesSidebar from '@/components/ShopComp/CategoriesSidebar';

const CategoriesSidebarWrapper = (props: any) => {
  const screens = useBreakpoint();
  const [openDrawer, setOpenDrawer] = useState(false);

  useEffect(() => {
    if (!screens.xs && openDrawer) {
      setOpenDrawer(false);
    }
  }, [screens]);

  return (
    <>
      {!screens.lg && (
        <ButtonDefault
          size={1}
          isWidthFull={false}
          rounded={false}
          roundedSm={true}
          variant={ButtonVariants.UNSTYLED}
          enableScaling={false}
          onClick={() => setOpenDrawer(true)}
          className='w-fit text-center px-2 bg-[#121212] text-sm group z-0 whitespace-nowrap'
        >
          <span className='text-sm w-fit px-4 md:px-0 gap-x-2 flex items-center'>
            {' '}
            <FunnelIcon />
            Category
          </span>
        </ButtonDefault>
      )}

      <Drawer
        title='Categories'
        placement='left'
        closable={true}
        onClose={() => setOpenDrawer(false)}
        open={openDrawer}
        width={450}
      >
        <CategoriesSidebar
          {...props}
          setOpenDrawer={setOpenDrawer}
          openDrawer={openDrawer}
          type={props.type}
        />
      </Drawer>

      {screens.lg && (
        <div className='lg:min-w-[257px] xl:min-w-[320px]'>
          <CategoriesSidebar
            {...props}
            setOpenDrawer={setOpenDrawer}
            openDrawer={openDrawer}
            type={props.type}
          />
        </div>
      )}
    </>
  );
};

export default CategoriesSidebarWrapper;
